import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { UserDto } from "@finora/types";

interface AuthState {
  token: string | null;
  user: UserDto | null;
  companyName: string | null;
  // false SAMO odmah nakon confirmAccount (korisnik nema firmu još) - vidi
  // LoginResponseDto.hasCompany i CompanyStep.tsx. Default true da postojeće
  // sesije (token sačuvan pre ove izmene, uvek sa firmom) ne budu pogrešno
  // tretirane kao "bez firme".
  hasCompany: boolean;
  login: (token: string, user: UserDto, companyName: string, hasCompany?: boolean) => void;
  setHasCompany: (hasCompany: boolean, companyName: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      companyName: null,
      hasCompany: true,
      login: (token, user, companyName, hasCompany = true) => set({ token, user, companyName, hasCompany }),
      setHasCompany: (hasCompany, companyName) => set({ hasCompany, companyName }),
      logout: () => set({ token: null, user: null, companyName: null, hasCompany: true }),
    }),
    { name: "finora-auth" },
  ),
);
